import React, {
  memo,
} from 'react';
import { Button } from '@mui/material';
import Grid24 from '../../../../../../../components/UI/Grid24';

function DialogPrintDownloadPrestacao({
  idPrestacaoContaClienteClicado,
  setOpenPrintDownloadPrestacao,
  handlePrintPrestacao,
  handleDownloadPrestacao,
}) {
  return (
    <>
      <Grid24 container isFormContainer spacing="1">
        Como você deseja obter a Prestação de Contas?
      </Grid24>
      <div style={{ display: 'flex', justifyContent: 'end', marginTop: '22px' }}>
        <Button
          onClick={() => setOpenPrintDownloadPrestacao(false)}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            handlePrintPrestacao(idPrestacaoContaClienteClicado);
            setOpenPrintDownloadPrestacao(false);
          }}
        >
          Exibir PDF
        </Button>
        <Button
          onClick={() => {
            handleDownloadPrestacao(idPrestacaoContaClienteClicado);
            setOpenPrintDownloadPrestacao(false);
          }}
        >
          Download Excel
        </Button>
      </div>

    </>
  );
}
export default memo(DialogPrintDownloadPrestacao);
